export default __webpack_public_path__ + "static/media/iot_configuration_hero.4886fc24.jpg";